import {
  Button,
  CircularProgress,
  ControllerAlert,
  ControllerModal,
  DialogActions,
  DialogContent,
  OutlinedInput,
  Stack,
  Text,
} from '@bymason-private/legacy-pattern-components';

export function UpdateSimStatus({
  iccid = '',
  newStatus,
  onSubmit,
  onClose,
  open,
  busy,
  error,
}: UpdateSimStatusProps) {
  return (
    <ControllerModal
      onClose={onClose}
      open={open}
      title='Change SIM status'
      data-modal-name='change-sim-status'
    >
      <DialogContent>
        <Stack gap={2} py={2}>
          <Text>{`Are you sure you want to ${newStatus} the SIM with ICCID:`}</Text>
          <OutlinedInput readOnly defaultValue={iccid} fullWidth />
          {error && (
            <ControllerAlert sx={{ width: '100%' }} severity='error'>
              <strong>Status update unsuccessful</strong>
              <div>{error}</div>
            </ControllerAlert>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color='secondary' onClick={onClose} size='medium' variant='text'>
          Cancel
        </Button>
        <Button color='primary' onClick={onSubmit} size='medium' variant='contained' disabled={busy || false}>
          {`Yes, ${newStatus}`}
          {busy && <CircularProgress size={14} />}
        </Button>
      </DialogActions>
    </ControllerModal>
  );
}

interface UpdateSimStatusProps {
  iccid: string;
  newStatus: 'enable' | 'disable';
  open: boolean;
  error?: string | null;
  busy?: boolean;
  onClose: () => void;
  onSubmit: () => void;
}
